import { StringLiteral } from 'typescript';
import { Carrier } from './';

export class Vessel {
  id: number;

  userData: {
    favorited: boolean,
    note: string
  };

  // register
  name: string;
  imo: string;
  regionId: string;
  regionName: string;
  countryId: string;
  countryName: string;
  callSign: string;
  mmsi: string;

  // management
  ownerId: string;
  ownerName: string;
  carrier: Carrier;
  previousNames: Array<string>;

  // capacity
  grossTonnage: string;
  netTonnage: string;
  dwt: string;
  avgTEU: string;
  maxTEU: string;
  reeferTEU: string;

  // construction
  shipType: string;
  portRegister: string;
  yearBuilt: string;
  shipBuilder: string;
  yardHull: string;
  handlingGear: string;
  length: string;
  beam: string;
  draught: string;

  // propulsion
  engineDesign: string;
  engineType: string;
  power: string;
  speed: string;
  sfc: string;
  co2: string;

  // image
  thumbnailUrl: string;

  constructor(json: any, accountType = '') {
    try {
      this.id = json.id || 0;
      this.imo = json.imo || '';
      this.name = json.name || '';
      this.thumbnailUrl = json.thumbnailUrl || '';

      this.userData = json.userData || {
        favorited: false,
        note: ''
      };
    } catch (ex) {
      this.setDefaults();
    }

    this.setRegister(json, accountType);
    this.setManagement(json, accountType);
    this.setCapacity(json, accountType);
    this.setConstruction(json, accountType);
    this.setPropulsion(json, accountType);
  }

  setDefaults() {
    this.id = 0;
    this.imo = '';
    this.name = '';
    this.thumbnailUrl = '';
    this.userData = {
      favorited: false,
      note: ''
    };
  }

  setRegister(json: any, accountType: string) {
    let show = true;
    try {
      if (json.country !== undefined) {
        this.countryId = show ? json.country.id : 'blurred text';
        this.countryName = show ? json.country.name : 'blurred text';
      } else {
        this.countryId = show ? '' : 'blurred text';
        this.countryName = show ? '' : 'blurred text';
      }
      this.callSign = show ? json.call_sign : 'blurred text';
      this.mmsi = show ? json.mmsi : 'blurred text';
    } catch (ex) {
      this.countryId = '';
      this.countryName = '';
      this.callSign = '';
      this.mmsi = '';
    }
  }

  setManagement(json: any, accountType: string) {
    let show = accountType !== '' && accountType !== 'Basic';
    try {
      this.carrier = new Carrier(json.carrier);
      if (!show) {
        this.carrier.name = 'blurred text';
      }
    } catch (ex) {
      this.carrier = new Carrier(null);
    }

    try {
      if (json.owner !== undefined) {
        this.ownerId = show ? json.owner.id : 'blurred text';
        this.ownerName = show ? json.owner.name : 'blurred text';
      } else {
        this.ownerId = show ? '' : 'blurred text';
        this.ownerName = show ? '' : 'blurred text';
      }

      this.previousNames = show ? json.previous_names : ['blurred text', 'blurred text', 'blurred text'];
    } catch (ex) {
      this.ownerId = '';
      this.ownerName = '';
      this.previousNames = [];
    }
  }

  setCapacity(json: any, accountType: string) {
    let show = accountType !== '' && accountType !== 'Basic';
    try {
      this.grossTonnage = show ? json.gross_tonnage : 'blurred text';
      this.netTonnage = show ? json.net_tonnage : 'blurred text';
      this.dwt = show ? json.dwt : 'blurred text';
      this.avgTEU = show ? json.avg_teu : 'blurred text';
      this.maxTEU = show ? json.max_teu : 'blurred text';
      this.reeferTEU = show ? json.reefer_teu : 'blurred text';
    } catch (ex) {
      this.grossTonnage = '';
      this.netTonnage = '';
      this.dwt = '';
      this.avgTEU = '';
      this.maxTEU = '';
      this.reeferTEU = '';
    }
  }

  setConstruction(json: any, accountType: string) {
    let show = accountType === 'Professional' || accountType === 'Enterprise';
    try {
      this.shipType = show ? json.ship_type : 'blurred text';
      this.portRegister = show ? json.port_registry : 'blurred text';
      this.yearBuilt = show ? json.year_built : 'blurred text';
      this.shipBuilder = show ? json.ship_builder : 'blurred text';
      this.yardHull = show ? json.yard_hull : 'blurred text';
      this.handlingGear = show ? json.handling_gear : 'blurred text';
      this.length = show ? json.length : 'blurred text';
      this.beam = show ? json.beam : 'blurred text';
      this.draught = show ? json.draught : 'blurred text';
    } catch (ex) {
      this.shipType = '';
      this.portRegister = '';
      this.yearBuilt = '';
      this.shipBuilder = '';
      this.yardHull = '';
      this.handlingGear = '';
      this.length = '';
      this.beam = '';
      this.draught = '';
    }
  }

  setPropulsion(json: any, accountType: string) {
    let show = accountType === 'Professional' || accountType === 'Enterprise';
    try {
      this.engineDesign = show ? json.engine_design : 'blurred text';
      this.engineType = show ? json.engine_type : 'blurred text';
      this.power = show ? json.power + ' KW' : 'blurred text';
      this.speed = show ? json.speed + ' Kn' : 'blurred text';
      this.sfc = show ? json.sfc : 'blurred text';
      this.co2 = show ? json.co2 : 'blurred text';
    } catch (ex) {
      this.engineDesign = '';
      this.engineType = '';
      this.power = '';
      this.speed = '';
      this.sfc = '';
      this.co2 = '';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/vessel.ts